import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableApprovalLogsView extends JetView {
    // Defining the tableApprovalLogsView class
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view for displaying logs
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'ActionTittle', // Column ID
                                    header: '', // Column header
                                    width: 65, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (obj.StateId !== 'P') {
                                            // Check if the state is not 'Pending'
                                            return '';
                                        } else {
                                            if (devConfig.getPermAction('approvalLogsApprove', 'Approve')) {
                                                // Check for approval permissions
                                                return "<span class='webix_icon wxi-close approve prm-approvalLogsApprove'></span><span class='webix_icon wxi-close torefuse prm-approvalLogsApprove'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide column based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        return (
                                            "<i class='flags " + obj.Country + "'></i>" // Display country flag
                                        );
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Time', // Column ID
                                    header: _('Fecha'), // Column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserNameRequest', // Column ID
                                    header: _('Usuario Solicita'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Field', // Column ID
                                    header: _('Campo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'OldValue', // Column ID
                                    header: _('Antiguo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'NewValue', // Column ID
                                    header: _('Nuevo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'StateId', // Column ID
                                    header: _('Estado'), // Column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Aprobada') }, // Approved
                                        { id: 'R', value: _('Rechazada') }, // Rejected
                                        { id: 'P', value: _('Pendiente') }, // Pending
                                    ],
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Imagen', // Column ID
                                    header: _('Imagen'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: true, // Hide column
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                torefuse: function (euv, id) {
                                    // Handler for 'torefuse' action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar el log?'), // Warning message
                                        ok: _('Rechazar log'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax() // AJAX request to update log
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Security/UpdateLogs',
                                                        '{"Id":"' + item.Id + '", "State":"R"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte', // Error alert
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de log actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    });
                                                                    item.StateId = 'R'; // Update state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for 'approve' action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el log?'), // Warning message
                                        ok: _('Aprobar log'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax() // AJAX request to update log
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Security/UpdateLogs',
                                                        '{"Id":"' + item.Id + '", "State":"A"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                console.log(
                                                                    text, // Log response
                                                                );
                                                                var json = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte', // Error alert
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de log actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    });
                                                                    item.StateId = 'A'; // Update state
                                                                    $$('datatable').refresh(); // Refresh datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                // Event handlers for datatable
                                onItemDblClick: function () {
                                    // Double-click event
                                    $$('editwin').show(); // Show edit window
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead option
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }
    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'UserManagement/GetUserLogsP'; // API URL for fetching user logs
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string
        this.on(this.app, 'requests:filter', (filterData) => {
            // Event listener for filter requests
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        var ttt = webix.ui({
            // Create edit window UI
            view: 'window',
            move: true, // Allow window to be moved
            id: 'editwin', // ID for the edit window
            fullscreen: screen.width < 500 ? true : false, // Fullscreen option based on screen width
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar'), align: 'center' }, // Label for editing
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // ID for the form
                elements: [
                    {
                        view: 'text', // Text input for User ID
                        label: _('ID Usuario'),
                        name: 'UserName',
                        readonly: true, // Read-only field
                    },
                    {
                        view: 'imageLabel', // Image label for displaying images
                        name: 'Imagen',
                        width: 500, // Width of the image
                        height: 500, // Height of the image
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button to close the window
                                value: _('Listo'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on click
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind the form to the datatable
    }
}

// Extend webix UI to create a custom imageLabel component
webix.protoUI(
    {
        name: 'imageLabel', // Component name
        setValue: function (value) {
            // Set value function for the component
            this.setHTML(
                "<img style='width:100%;height: 100%;' src='" + value + "'></img>", // Set HTML content for the image
            );
        },
    },
    webix.ui.label, // Base component
);

// FILE DOCUMENTED
